<template>
    <div class="contact-info">
        <div>
            <div class="shadow">
                <div style="display: flex;align-items: flex-end;">
                    <span class="d-title">紧急联系人信息</span>
                    <span style="flex: 1;text-align: right;" class="d-edit" @click="isEdit = !isEdit">编辑</span>
                </div>
                <div style="margin-top: 0.2rem;">
                    <div style="background-color: #909399;height: 1px;width: 100%;"></div>
                </div>
                <div style="margin-top: 0.2rem;" id="b-content">
                    <div v-if="!isEdit" style="padding: 0.1rem 0 0.1rem 0;">
                        <div v-for="(item, index) in contactInfoFormLoop" :key="index">
                            <el-row type="flex" justify="space-between">
                                <el-col :span="5" class="col">紧急联系人姓名:</el-col>
                                <el-col :span="7" class="col-n col">{{ item.name }}</el-col>
                                <el-col :span="5" class="col">联系人关系:</el-col>
                                <el-col :span="7" class="col-n col">{{ item.relation_name }}</el-col>
                            </el-row>
                            <el-row type="flex" justify="space-between">
                                <el-col :span="5" class="col">联系人电话:</el-col>
                                <el-col :span="7" class="col-n col">{{ item.tel_phone }}</el-col>
                                <el-col :span="5" class="col"></el-col>
                                <el-col :span="7" class="col-n col"></el-col>
                            </el-row>
                        </div>
                    </div>
                    <div v-else>
                        <el-form ref="contactInfoForm" :model="contactInfoForm" label-width="115px" size="medium">
                            <div v-for="(item, index) in contactInfoFormLoop" :key="index"
                                style="border-bottom: 1px solid #eeeaea;margin-bottom: 0.2rem;">
                                <el-form-item label="紧急联系人姓名">
                                    <el-input v-model.trim="item.name" clearable></el-input>
                                </el-form-item>
                                <el-form-item label="联系人关系">
                                    <el-select v-model="item.relation" placeholder="请选择" style="width: 100%" clearable
                                        filterable size="medium">
                                        <el-option :value="1" label="父母">
                                        </el-option>
                                        <el-option :value="2" label="配偶">
                                        </el-option>
                                        <el-option :value="3" label="子女">
                                        </el-option>
                                        <el-option :value="4" label="其他">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="联系人电话">
                                    <el-input v-model.trim="item.tel_phone" clearable></el-input>
                                </el-form-item>
                                <div style="text-align: right;margin-bottom:0.2rem;" v-if="index !== 0">
                                    <span style="color: #F56C6C;cursor: pointer" @click="delLoop(index)">
                                        <i class="el-icon-delete"></i>
                                        <span>删除本条</span>
                                    </span>
                                </div>
                            </div>
                            <div style="width: 100%;text-align: center;cursor: pointer;border: 1px dashed #ccc;height: 25px;border-radius: 8px;line-height: 25px;margin-bottom: 0.2rem;font-size: medium;"
                                @click="addContactInfoFrom">
                                + 新增
                            </div>
                            <div style="text-align: center;width: 100%!important;">
                                <el-button type="primary" @click="onSubmit">提交</el-button>
                                <el-button @click.native="isEdit = !isEdit">取消</el-button>
                            </div>
                        </el-form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { common } from '../../../../static/mixins/common'
export default {
    name: 'ContactInfo',
    mixins: [common],
    props: {
        adminuser_id: {
            type: Number
        },
        adminuser_name: {
            type: String
        }
    },
    data() {
        return {
            contactInfoForm: {},
            contactInfoFormLoop: [
                {
                    name: '',
                    relation: '',
                    tel_phone: ''
                }
            ],
            isEdit: false,
            adminuserId: '',
            adminuserName: ''
        }
    },
    methods: {
        onSubmit() {
            this.$axios.put('api/api3_update_contact_info', {
                formData: this.contactInfoFormLoop,
                admin_user_id: this.adminuserId
            }).then(({ data }) => {
                if (data.code === 200) {
                    this.contactInfoFormLoop = data.data
                    if (data.data.length === 0) {
                        this.contactInfoFormLoop = [{
                            name: '',
                            relation: '',
                            tel_phone: ''
                        }]
                    }
                    this.$message.success(data.msg)
                } else {
                    this.$message.error(data.msg)
                }
            }).catch()
        },
        getAdminUserContactInfo(admin_user_id) {
            this.resetForm()
            this.ysyMAdminUserContactInfoOptions = []
            this.ysyMGetAdminUserContactInfo(admin_user_id)
        },
        resetForm() {
            this.contactInfoFormLoop.map(item => {
                item.name = ''
                item.relation = ''
                item.tel_phone = ''
            })
        },
        addContactInfoFrom() {
            this.contactInfoFormLoop.push({
                name: '',
                relation: '',
                tel_phone: ''
            })
        },
        delLoop(no) {
            this.contactInfoFormLoop.splice(no, 1)
        }
    },
    watch: {
        adminuser_id: {
            immediate: true,
            handler(n, o) {
                this.adminuserId = null
                if (n !== o) {
                    this.adminuserId = n
                    this.getAdminUserContactInfo(n)
                }
            }
        },
        adminuser_name: {
            immediate: true,
            handler(n, o) {
                if (n !== o) {
                    this.adminuserName = n
                }
            }
        },
        ysyMAdminUserContactInfoOptions: {
            handler(n, o) {
                if (n !== o) {
                    if (n) {
                        this.contactInfoFormLoop = n
                        if (n.length === 0) {
                            this.contactInfoFormLoop = [{
                                name: '',
                                relation: '',
                                tel_phone: ''
                            }]
                        }
                    }
                }
            },
        },
    }
}
</script>

<style scoped>
.d-title {
    font-size: x-large;
    font-weight: bold;
}

.d-edit {
    font-size: medium;
    font-weight: bold;
    color: #409EFF;
    cursor: pointer;
}

/* .col {
    font-size: larger;
    font-weight: bold;
} */

/* .col-n {
    color: slategrey;
} */

#b-content .el-row {
    margin-bottom: 0.6rem;
}

.shadow {
    padding: 0.3rem 0.6rem;
    border: 1px solid #ccc;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, .3);
    margin: 0.2rem;
}

.over-title {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

#b-content>>>.el-form-item {
    width: 45% !important;
    display: inline-block !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/authority/UserInfoTab/ContactInfo.vue